__turbopack_context__.v({
  "badgeStyles": "channelGuide-module-scss-module__Z4V6fG__badgeStyles",
  "channelCardStripWrapper": "channelGuide-module-scss-module__Z4V6fG__channelCardStripWrapper",
  "channelGuideContentWrapper": "channelGuide-module-scss-module__Z4V6fG__channelGuideContentWrapper",
  "channelGuidePaddings": "channelGuide-module-scss-module__Z4V6fG__channelGuidePaddings",
  "channelGuideSkeletonWrapper": "channelGuide-module-scss-module__Z4V6fG__channelGuideSkeletonWrapper",
  "channelIcon": "channelGuide-module-scss-module__Z4V6fG__channelIcon",
  "channelList": "channelGuide-module-scss-module__Z4V6fG__channelList",
  "downloadLinkDesktop": "channelGuide-module-scss-module__Z4V6fG__downloadLinkDesktop",
  "downloadLinkMobile": "channelGuide-module-scss-module__Z4V6fG__downloadLinkMobile",
  "downloadTextWrapper": "channelGuide-module-scss-module__Z4V6fG__downloadTextWrapper",
  "explicitContainerWrapper": "channelGuide-module-scss-module__Z4V6fG__explicitContainerWrapper",
  "hasStickyBar": "channelGuide-module-scss-module__Z4V6fG__hasStickyBar",
  "headerAreaWrapper": "channelGuide-module-scss-module__Z4V6fG__headerAreaWrapper",
  "iconStyle": "channelGuide-module-scss-module__Z4V6fG__iconStyle",
  "linkColor": "channelGuide-module-scss-module__Z4V6fG__linkColor",
  "packageBySearchParamWrapper": "channelGuide-module-scss-module__Z4V6fG__packageBySearchParamWrapper",
  "radioSelectContainer": "channelGuide-module-scss-module__Z4V6fG__radioSelectContainer",
  "selectOption": "channelGuide-module-scss-module__Z4V6fG__selectOption",
  "selectPlanHeaderSubTitleStyles": "channelGuide-module-scss-module__Z4V6fG__selectPlanHeaderSubTitleStyles",
  "selectorStyles": "channelGuide-module-scss-module__Z4V6fG__selectorStyles",
  "selectorsWrapper": "channelGuide-module-scss-module__Z4V6fG__selectorsWrapper",
  "showMore": "channelGuide-module-scss-module__Z4V6fG__showMore",
  "showMoreAreaStyles": "channelGuide-module-scss-module__Z4V6fG__showMoreAreaStyles",
  "showMoreButton": "channelGuide-module-scss-module__Z4V6fG__showMoreButton",
  "showMoreTextStyles": "channelGuide-module-scss-module__Z4V6fG__showMoreTextStyles",
  "tabsSelectorWrapper": "channelGuide-module-scss-module__Z4V6fG__tabsSelectorWrapper",
  "xlDescription": "channelGuide-module-scss-module__Z4V6fG__xlDescription",
  "ymmButton": "channelGuide-module-scss-module__Z4V6fG__ymmButton",
  "ymmPreTextBar": "channelGuide-module-scss-module__Z4V6fG__ymmPreTextBar",
  "ymmTextBar": "channelGuide-module-scss-module__Z4V6fG__ymmTextBar",
  "ymmTriggerWrapper": "channelGuide-module-scss-module__Z4V6fG__ymmTriggerWrapper",
});
